<script setup lang="ts">
import { useSelectReason } from '../../../model/additional-info/billing/info-chargeback/select-reason.hook'
import ListTaskInfo from '../../task-info/ListTaskInfo.vue'
import RowTaskInfo from '../../task-info/RowTaskInfo.vue'
import SelectReason from './info-chargeback/SelectReason.vue'

defineOptions({
  name: 'InfoChargeback',
})

const { isRequired } = useSelectReason()

</script>

<template>
  <ListTaskInfo>
    <RowTaskInfo
      title="Reason"
      :required="isRequired"
    >
      <SelectReason />
    </RowTaskInfo>
  </ListTaskInfo>
</template>
